package com.macrofocus.high_d.axis.locations

import com.macrofocus.common.properties.Property
import com.macrofocus.high_d.axis.Alignment
import com.macrofocus.high_d.axis.AxisModel
import com.macrofocus.order.MutableVisibleOrder
import kotlin.math.min

class DefaultAxisLocations<Row, C>(axisOrder: MutableVisibleOrder<AxisModel<Row, C>>, maxDimensions: Property<Int>) : AxisLocations<Row, C> {
    private val axisOrder: MutableVisibleOrder<AxisModel<Row, C>>
    private val maxDimensions: Property<Int>
    private var dragged: AxisModel<*,*>? = null
    private var draggedLocation = Double.NaN

    override fun getLocation(alignment: Alignment, axisModel: AxisModel<Row, C>?): Double {
        return if (dragged === axisModel) {
            draggedLocation
        } else {
            getPosition(alignment, axisModel)
        }
    }

    override fun setLocation(alignment: Alignment, axisModel: AxisModel<Row, C>, l: Double) {
        val previous: AxisModel<Row, C>? = axisOrder.previous(axisModel)
        if (previous != null && l < getLocation(alignment, previous)) {
            axisOrder.moveToPrevious(axisModel, false)
        }
        val next: AxisModel<Row, C>? = axisOrder.next(axisModel)
        if (next != null && l > getLocation(alignment, next)) {
            axisOrder.moveToNext(axisModel, false)
        }
    }

    override fun drag(alignment: Alignment, model: AxisModel<Row, C>, l: Double) {
        dragged = model
        draggedLocation = l
        setLocation(alignment, model, l)
    }

    override fun stopDragging() {
        dragged = null
    }

    fun getPosition(alignment: Alignment, axisModel: AxisModel<Row, C>?): Double {
        val index: Int = axisOrder.indexOf(axisModel)
        val visibleAxisCount: Int = min(maxDimensions.value, axisOrder.size())
        when (alignment) {
            Alignment.Left -> return index / visibleAxisCount.toDouble()
            Alignment.Center -> {
                val margins = 1.0 / visibleAxisCount
                val margin = margins / 2.0
                return margin + index / visibleAxisCount.toDouble()
            }
            Alignment.Fill -> return index / (visibleAxisCount - 1).toDouble()
            Alignment.Right -> return (index + 1) / visibleAxisCount.toDouble()
        }
        return Double.NaN
    }

    init {
        this.axisOrder = axisOrder
        this.maxDimensions = maxDimensions
    }
}